<div class="flex" style="margin-top: 8px;">
  <div class="card w-full">
    <div class="p-datatable p-component p-datatable-hoverable-rows">
      <div class="p-datatable-header">
        <div class="flex flex-column sm:flex-row justify-content-between">
          <div class="flex flex-column md:flex-row">
            <button
              [label]="'common.new' | transloco"
              pButton
              pRipple
              class="md:mr-2 p-button-primary mb-2 md:mb-0"
              routerLink="default-asset-representations/new"
              icon="pi pi-plus"
            ></button>
            <button
              [label]="'common.delete' | transloco"
              [disabled]="selected.length == 0"
              (click)="confirmAndDeleteSelected()"
              pButton
              pRipple
              class="p-button-danger mb-2 sm:mb-0"
              icon="pi pi-trash"
            ></button>
          </div>
          <div *ngIf="!filtersFilled" class="flex flex-column md:flex-row justify-content-end">
            <button
              [label]="'common.filters' | transloco"
              (click)="filtersVisible = !filtersVisible"
              pButton
              class="p-button-secondary"
              icon="pi pi-sliders-h"
            ></button>
          </div>
          <div *ngIf="filtersFilled" class="flex flex-column md:flex-row justify-content-end">
            <button
              [label]="'common.filters' | transloco"
              (click)="filtersVisible = !filtersVisible"
              pButton
              class="p-button-secondary filtersFilled"
              icon="pi pi-filter"
            ></button>
          </div>
        </div>
      </div>
      <p-table
        [(selection)]="selected"
        [(first)]="first"
        [(rows)]="rows"
        [value]="representations"
        [totalRecords]="totalRepresentations"
        [responsive]="true"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        [rowsPerPageOptions]="[10,25,50]"
        [lazy]="true"
        (onLazyLoad)="onPageChange($event)"
        styleClass="p-datatable-striped"
        sortField="name"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="selection-column-width"></th>
            <th pSortableColumn="name">
              {{'attribute.name' | transloco}}<p-sortIcon field="name"></p-sortIcon></th>
            <th pSortableColumn="description">
              {{'attribute.description' | transloco}}<p-sortIcon field="description"></p-sortIcon></th>
            <th>{{'attribute.icon' | transloco}}</th>
            <th class="w-10rem">
              {{'common.actions' | transloco}}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-representation>
          <tr *ngIf="!loadingRepresentations" class="fadein">
            <td>
              <span class="p-column-title bold">{{'common.select' | transloco}}</span>
              <p-tableCheckbox [value]="representation"></p-tableCheckbox>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
              {{representation.name}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
              {{representation.description}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.icon' | transloco}}</span>
              <img
                *ngIf="representation.icon else emptyIcon"
                [src]="'data:image/png;base64,' + representation.icon"
                [alt]="'attribute.icon' | transloco"
                height="30"
              >
              <ng-template #emptyIcon>
                <i>{{'empty.icon' | transloco}}</i>
              </ng-template>
            </td>
            <td>
              <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
              <div class="flex justify-content-end">
                <button
                  [routerLink]="['default-asset-representations', representation.name, 'edit']"
                  pButton
                  pRipple
                  class="p-button-rounded btn-primary-light mr-2"
                  icon="pi pi-pencil"
                ></button>
                <button
                  (click)="confirmAndDelete(representation)"
                  pButton
                  pRipple
                  class="p-button-rounded btn-danger-light"
                  icon="pi pi-trash"
                ></button>
              </div>
            </td>
          </tr>
          <tr *ngIf="loadingRepresentations" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between" *ngIf="totalRepresentations == 0">
            {{'pagination.empty' | transloco}}
          </div>
          <div class="flex align-items-center justify-content-between" *ngIf="totalRepresentations > 0">
            {{'pagination.showing' | transloco}} {{first+1}}
            {{'pagination.to' | transloco}} {{(first+rows) >= totalRepresentations ? totalRepresentations : (first+rows)}}
            {{'pagination.of' | transloco}} {{totalRepresentations}}
            {{(totalRepresentations > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>


<p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="name">{{'attribute.name' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.name"
          [focus]="filtersVisible"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          pInputText
          appAutoFocus
          class="w-full"
          id="name"
          type="text"
        >
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="description">{{'attribute.description' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.description"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          pInputText
          class="w-full"
          id="description"
          type="text"
        >
      </div>
    </div>
    <div class="col-12">
      <p-button
        [label]="'common.filter' | transloco"
        [disabled]="!(
          currentFilters.name ||
          currentFilters.description
        )"
        (onClick)="filtersVisible = false; applyFilters()"
        styleClass="p-button-primary mx-2 mt-2"
        type="button"
      ></p-button>
      <p-button
        [label]="'common.clear' | transloco"
        (click)="resetFilters(); filtersVisible = false;"
        styleClass="p-button-danger"
        type="button"
      ></p-button>
    </div>
  </div>
</p-sidebar>
